import { Chip, ChipProps, styled } from "@mui/material";
import React from "react";

import { MissionIncidentDisplayStatus } from "src/graphql-next/generated/types";

const LABEL: Record<MissionIncidentDisplayStatus, string> = {
  [MissionIncidentDisplayStatus.RequestTransmitted]: "Transmise",
  [MissionIncidentDisplayStatus.InterventionScheduled]: "Intervention prévue",
  [MissionIncidentDisplayStatus.Completed]: "Terminée",
};

interface Props extends ChipProps {
  status: MissionIncidentDisplayStatus;
}

const StyledChip = styled(Chip)<{ status: MissionIncidentDisplayStatus }>`
  background-color: ${(props) => props.theme.palette.missionIncident.status[props.status]};
  color: ${(props) => props.theme.palette.common.white};
  span {
    font-weight: bold;
  }
`;

export const ChipMissionIncident = ({ status, ...chipProps }: Props) => (
  <StyledChip status={status} label={LABEL[status]} {...chipProps} />
);
